/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LossDueToEffectiveDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LossDueToEffectiveDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/EditAction/Content/Edit/Content/LossDueToEffectiveDate"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let insuranceValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
})
let paymentPlanValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
})
let treatmentPlanValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
})
let aggregateData = fromHelpers.getValue(insuranceValueData, paymentPlanValueData, treatmentPlanValueData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="LossDueToEffectiveDate.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1wV6JM': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Loss due to effective date"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insurance"
 data="payment_plan"
 data="treatment_plan"
 aggregate="helpers.js getValue"
 text={aggregateData}
 weight="medium"
 color={dtColorsBlack}
/>
</div>
{children}
</React.Fragment>)
}